export default __webpack_public_path__ + "static/media/hall_of_fame_bg_center.3fa8c304.png";